// SNs of Articles (News entries) that are press releases.
// When a new press release is published in the CMS, add its SN here so it
// appears under News → Press Releases. Find the SN on the entry in Strapi.
export const pressReleaseSNs = [1044, 1045, 1046]
